/**
 * #1150 — the single place Novig presentation inputs enter the shared UI.
 *
 * Null (the default, and every production render today) means no Novig
 * source: the board shows no Novig column and Game Detail no Novig tab, so
 * existing venues render exactly as before. The future producer/adapter
 * provides this value; the dev fixture injector and tests provide synthetic
 * values. It is a delivery seam, not a store: it never subscribes, polls or
 * places orders. Contract: docs/261012NovigDiscoveryTicketPlan.md.
 */
import { createContext, useContext } from 'react';
import type { NovigAccountReadiness, NovigBoardQuotes } from './presenter';

export interface NovigVenueSeam {
  /** Full-game moneylines by board `GameRow.key` (supplier maps identity). */
  readonly quotes: NovigBoardQuotes;
  /** The selected org's Novig trading readiness, independent of feed state. */
  readonly account: NovigAccountReadiness;
}

export const NovigVenueSeamContext = createContext<NovigVenueSeam | null>(null);

export function useNovigVenueSeam(): NovigVenueSeam | null {
  return useContext(NovigVenueSeamContext);
}
